module.exports = __webpack_public_path__ + "static/media/ATC.319ffc8e.webp";